import React from "react";
import { safeFetch } from '../../../utils/security';
import { toast } from 'react-toastify';
import DocsCards from "components/blocks/Grids/DocsCards";

const handleDownload = async (sasUri, nombreOriginal) => {
  try {
    const response = await safeFetch(sasUri);
    if (!response.ok) throw new Error();

    const blob = await response.blob();
    const ext = sasUri.split('.').pop()?.split('?')[0] ?? "";
    const hasExt = nombreOriginal.includes('.');
    const fileName = hasExt ? nombreOriginal : `${nombreOriginal}.${ext}`;

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch {
    toast.error('Error al descargar el archivo. Por favor, inténtalo de nuevo.');
  }
};

const FilesNoticesGrid = ({ documents }) => (
  <DocsCards
    items={Array.isArray(documents) ? documents : []}
    getName={(d) => d.nombreOriginal ?? ""}
    onDownload={(d) => handleDownload(d.sasUri, d.nombreOriginal)}
    emptyMessage="No hay archivos adjuntos."
  />
);

export default FilesNoticesGrid;
